const GOOGLE_SCRIPT_ID = "google-sso-script";

// Accept a callback to execute after the script loads
const loadGoogleScript = (callback) => {
  if (document.getElementById(GOOGLE_SCRIPT_ID)) {
    console.log("[Google SSO] Script already loaded.");
    // If already loaded, but the callback wasn't executed, try to run it now.
    // However, if window.google is not ready, this means the script is still
    // in the process of setting up. We rely on the onload event for certainty.
    if (window.google && typeof callback === "function") {
      callback();
    }
    return;
  }

  const script = document.createElement("script");
  script.src = "https://accounts.google.com/gsi/client";
  script.async = true;
  script.defer = true;
  script.id = GOOGLE_SCRIPT_ID;

  // IMPORTANT: Execute the callback when the script is fully loaded
  if (typeof callback === "function") {
    script.onload = callback;
    script.onreadystatechange = function () {
      if (this.readyState === "complete") {
        callback();
      }
    };
  }

  document.head.appendChild(script);
  console.log("[Google SSO] Script injected.");
};

// Accept a callback and pass it to loadGoogleScript
export const initiateGoogleSSO = (integration, callback) => {
  try {
    if (integration && integration.enabled && integration.config?.clientId) {
      console.log("[Google SSO] Initializing Google SSO...");
      loadGoogleScript(callback); // Pass the callback here
    } else {
      console.log("[Google SSO] Disabled or missing clientId.");
    }
  } catch (err) {
    console.warn("Failed to load Google SSO:", err);
  }
};
